
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

export default function TextArea (props) {
    return (
        <TextareaAutosize
            minRows="3"
            maxRows="15"
            {...props}
        />
    )
}
